module.exports = __webpack_public_path__ + "img/zj7.f04bcf60.png";